<template>
	<base-modal
		:visible="visible"
		:title="title"
		width="400px"
		:footer="showCancel || showConfirm"
		@update:visible="$emit('update:visible', $event)"
	>
		<view class="confirm-body">
			<view class="confirm-icon" :class="'confirm-icon--' + type">
				<text class="confirm-emoji">{{ iconMap[type] }}</text>
			</view>
			<text class="confirm-content">{{ content }}</text>
		</view>

		<template #footer>
			<m-btn v-if="showCancel" type="ghost" size="default" @tap="onCancel">
				{{ cancelText }}
			</m-btn>
			<m-btn v-if="showConfirm" :type="confirmType" size="default" @tap="onConfirm">
				{{ confirmText }}
			</m-btn>
		</template>
	</base-modal>
</template>

<script setup>
	const props = defineProps({
		visible: { type: Boolean, default: false },
		type: {
			type: String,
			default: 'info',
			validator: (v) => ['success', 'info', 'error', 'warning'].includes(v)
		},
		title: { type: String, default: '提示' },
		content: { type: String, default: '' },
		showCancel: { type: Boolean, default: true },
		showConfirm: { type: Boolean, default: true },
		cancelText: { type: String, default: '取消' },
		confirmText: { type: String, default: '确定' },
		confirmType: {
			type: String,
			default: 'primary',
			validator: (v) => ['primary', 'danger', 'success', 'warning'].includes(v)
		}
	})

	const emit = defineEmits(['update:visible', 'confirm', 'cancel'])

	const iconMap = {
		success: '✅',
		info: 'ℹ️',
		error: '❌',
		warning: '⚠️'
	}

	function onConfirm() {
		emit('update:visible', false)
		emit('confirm')
	}

	function onCancel() {
		emit('update:visible', false)
		emit('cancel')
	}
</script>

<style scoped>
	.confirm-body {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 14px;
		padding: 8px 0 4px;
	}

	.confirm-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.confirm-emoji {
		font-size: 48px;
		line-height: 1;
	}

	.confirm-icon--success .confirm-emoji { filter: drop-shadow(0 2px 6px var(--success)); }
	.confirm-icon--info .confirm-emoji { filter: drop-shadow(0 2px 6px var(--info)); }
	.confirm-icon--error .confirm-emoji { filter: drop-shadow(0 2px 6px var(--danger)); }
	.confirm-icon--warning .confirm-emoji { filter: drop-shadow(0 2px 6px var(--warning)); }

	.confirm-content {
		font-size: 14px;
		line-height: 1.6;
		color: var(--text-secondary);
		text-align: center;
		word-break: break-word;
	}

	/* ===== 移动端 ===== */
	@media (max-width: 768px) {
		.confirm-emoji {
			font-size: 40px;
		}

		.confirm-content {
			font-size: 13px;
		}
	}
</style>
